import React from 'react'

export default function FaceFeature({ scaleX, fill, outline, verticalOffset }) {
  return (
    <g transform={`scale(${scaleX},1) translate(0,${verticalOffset})`}>
      <path
        d="M21.8801 10.2879H3.57008L1.08008 4.85791L1.83008 15.9979C4.59008 18.5479 9.47008 19.0579 12.7201 19.0579C15.9701 19.0579 20.8501 18.5479 23.6101 15.9979L24.3601 4.85791L21.8801 10.2879Z"
        fill={fill}
        stroke={outline}
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M10.8803 10.3179C10.8803 10.3179 10.3803 14.9378 10.3003 18.9078"
        stroke={outline}
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
      <path
        d="M8.07024 10.1479C8.07024 10.1479 7.57023 14.768 7.49023 18.738"
        stroke={outline}
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
      <path
        d="M6.42032 10.1479C6.42032 10.1479 5.92033 14.768 5.84033 18.738"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M4.03024 9.81787C4.03024 9.81787 3.66025 13.2579 3.51025 16.7479"
        stroke={outline}
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
      <path
        d="M14.5703 10.3179C14.5703 10.3179 15.0703 14.9378 15.1503 18.9078"
        stroke={outline}
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
      <path
        d="M17.3701 10.1479C17.3701 10.1479 17.8701 14.768 17.9501 18.738"
        stroke={outline}
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
      <path
        d="M19.0303 10.1479C19.0303 10.1479 19.5303 14.768 19.6103 18.738"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M21.4204 9.81787C21.4204 9.81787 21.7904 13.2579 21.9404 16.7479"
        stroke={outline}
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
    </g>
  )
}
